export default __webpack_public_path__ + "static/media/map-fs-icon.461f7c94.svg";